<template>
  <div class="my-warning">
    <span class="title">业务总览</span>
    <div class="my-warning-body">

      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <!-- <p>提醒日期</p> -->
              <el-date-picker size="small" style="width: 100%;" v-model="dates" value-format="yyyy-MM" type="monthrange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>

          </div>
          <div class="search-action">
            <el-button size="small" icon="el-icon-search" type="primary" @click="getList()">查询</el-button>
            <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
          </div>
        </div>
      </div>
      <div class="chart-content">
        <div class="chart-card">
          <div class="chart-title"><span class="title-text" @click="pushRouter('manageCategory')">管理类型统计</span></div>
          <div class="chart-main" id="manage-chart"></div>
        </div>
        <div class="chart-card">
          <div class="chart-title"><span class="title-text" @click="pushRouter('dangerWasterData')">跨省处置情况</span></div>
          <div class="chart-main" id="transp-chart"></div>
        </div>
        <div class="chart-card">
          <div class="chart-title"><span class="title-text" @click="pushRouter('dangerWasterData')">处置方式</span></div>
          <div class="chart-main" id="hanletype-chart"> </div>
        </div>
        <div class="chart-card">
          <div class="chart-title"><span class="title-text" @click="pushRouter('dangerWasterData')">危废数据</span></div>
          <div class="chart-main" id="dangerdata-chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as echarts from "echarts";

export default {
  data() {
    return {
      searchParams: {
        startDate: "",
        endDate: "",
      },
      dates: [],
      dangerData: [],
      handleTypes: [],
      manageCategorys: [],
      transProvinces: [],
    }
  },
  methods: {
    pushRouter(src) {
      this.$router.push(src)
    },
    getList() {
      if (this.dates && this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      } else {
        this.searchParams.startDate = this.searchParams.endDate = null;
      }
      const params = {
        ...this.searchParams
      };
      const url = this.$api.statistics.getBusinessView;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { dangerData, handleTypes, manageCategorys, transProvinces } = res.data.data;

          this.dangerData = dangerData;
          this.handleTypes = handleTypes;
          this.manageCategorys = manageCategorys;
          this.transProvinces = transProvinces;
          this.drawAllCharts()
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    drawAllCharts() {

      this.drawManageCategoryChart();
      this.drawTransPChart();
      this.drawHandleTypeChart();
      this.drawDangerDataChart();
    },
    drawManageCategoryChart() {
      const colors = {
        "重点监管": "#AE3D2E",
        "简化管理": "#FEF757",
        "登记管理": "#5594DF",
      }

      let pieData = this.manageCategorys;

      let option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            // 获取数据
            const data = pieData[params.dataIndex];
            let jurisdictions = data.jurisdictions;
            let thColor = '#fff'
            if (params.name == '简化管理') {
              thColor = "#808080"
            }
            // 构建tooltip内容
            let tooltipContent = '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
            tooltipContent += '<tr style="background-color:' + params.color + ';color:' + thColor + '">'
            tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
            tooltipContent += '<th style="border: 1px solid ' + params.color + '; padding: 5px;">数量（家）</th>'; // 设置表头边框和内边距
            tooltipContent += '</tr>';
            jurisdictions.forEach(function (jurisdiction) {
              tooltipContent += '<tr>';
              tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.count}</td>`; // 设置单元格边框和内边距
              tooltipContent += '</tr>';
            });
            tooltipContent += '</table></div>';
            let title = `<div style="margin-bottom:7px"> ${params.marker}  ${data.name} : ${data.value} 家 </div> `
            return `${title}  ${tooltipContent}`;
          }
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        graphic: {
          type: 'text',     // 类型：文本
          left: 'center',
          top: 'middle',
          silent: true,     // 不响应事件
          invisible: pieData.length > 0,   // 有数据就隐藏
          style: {
            fill: '#9d9d9d',
            fontWeight: 'bold',
            text: '暂无数据',
            fontFamily: 'Microsoft YaHei',
            fontSize: '25px'
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '55%'],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  return colors[params.name];
                }
              }
            },
            label: {
              show: true,
              normal: {
                formatter: '{b}\n \n \t{c} 家',
                textStyle: {
                  fontSize: 14,
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              // length2: 50,
              // length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData
          }
        ]
      };
      const myChart = echarts.init(document.getElementById("manage-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawTransPChart() {
      let pieData = this.transProvinces;

      let option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        graphic: {
          type: 'text',     // 类型：文本
          left: 'center',
          top: 'middle',
          silent: true,     // 不响应事件
          invisible: pieData.length > 0,   // 有数据就隐藏
          style: {
            fill: '#9d9d9d',
            fontWeight: 'bold',
            text: '暂无数据',
            fontFamily: 'Microsoft YaHei',
            fontSize: '25px'
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '55%'],
            avoidLabelOverlap: false,

            label: {
              show: true,
              normal: {
                formatter: '{b}\n \n \t{c} 家',
                textStyle: {
                  fontSize: 14,
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              length2: 50,
              length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData
          }
        ]
      };
      const myChart = echarts.init(document.getElementById("transp-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawHandleTypeChart() {
      let pieData = this.handleTypes;
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            // 获取数据
            // const data = pieData[params.dataIndex];
            let thColor = '#fff'

            const { value, marker, name, data, color, percent } = params;
            let jurisdictions = data.jurisdictions;
            // 构建tooltip内容
            let tooltipContent = '<div style=""> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
            tooltipContent += '<tr style="background-color:' + color + ';color:' + thColor + '">'
            tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 20px;">辖区</th>'; // 设置表头边框和内边距
            tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 20px;">比例</th>'; // 设置表头边框和内边距
            tooltipContent += '</tr>';
            jurisdictions.forEach(function (jurisdiction) {
              const percentJ = (jurisdiction.count / value * 100).toFixed(2);

              tooltipContent += '<tr>';
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 20px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 20px;">${percentJ} %</td>`; // 设置单元格边框和内边距
              tooltipContent += '</tr>';
            });
            tooltipContent += '</table></div>';
            let title = ` <div style="margin-bottom:7px"> ${marker}  ${name} : ${percent} % </div> `
            return `<div style="display:flex;flex-direction: column;align-items: center;"> ${title}  ${tooltipContent}</div>`;
          }
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        graphic: {
          type: 'text',     // 类型：文本
          left: 'center',
          top: 'middle',
          silent: true,     // 不响应事件
          invisible: pieData.length > 0,   // 有数据就隐藏
          style: {
            fill: '#9d9d9d',
            fontWeight: 'bold',
            text: '暂无数据',
            fontFamily: 'Microsoft YaHei',
            fontSize: '25px'
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '55%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              normal: {
                formatter: '{b}\n \n \t{d} %',
                textStyle: {
                  fontSize: 14,
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              length2: 50,
              length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData
          }
        ]
      };
      const myChart = echarts.init(document.getElementById("hanletype-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawDangerDataChart() {
      const data = this.dangerData;
      let option = {
        // title: {
        //   text: '危废数据'
        // },
        graphic: {
          type: 'text',     // 类型：文本
          left: 'center',
          top: 'middle',
          silent: true,     // 不响应事件
          invisible: data.length > 0,   // 有数据就隐藏
          style: {
            fill: '#9d9d9d',
            fontWeight: 'bold',
            text: '暂无数据',
            fontFamily: 'Microsoft YaHei',
            fontSize: '25px'
          }
        },
        legend: {},
        toolbox: {
          feature: {
            // dataView: { show: true, readOnly: false }, 
            magicType: {            //动态类型切换
              show: true,           //是否显示该工具
              type: ['line', 'bar', 'stack'], //启用的动态类型
              title: {
                line: '切换为折线图',
                bar: '切换为柱状图',
                stack: "切换为堆叠"
              }
            },
            restore: { show: true, title: "还原" },
            // saveAsImage: { show: true }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: function (params) {

            let thColor = '#fff'
            let title = "<div style='margin-bottom:5px'>"
            params.forEach(item => {
              title += `<div>${item.marker} ${item.seriesName}：${item.value[item.seriesName]} 吨 </div>`;
            });
            title += "</div>"
            const { data, color } = params[0];
            let jurisdictions = data.jurisdictions;
            // 构建tooltip内容
            let tooltipContent = '<div style=""> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
            tooltipContent += '<tr style="background-color:' + color + ';color:' + thColor + '">'
            tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">辖区</th>'; // 设置表头边框和内边距
            tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">产生量（吨）</th>'; // 设置表头边框和内边距
            tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">处置量（吨）</th>'; // 设置表头边框和内边距
            tooltipContent += '<th style="border: 1px solid ' + color + '; padding: 5px 10px;">贮存量（吨）</th>'; // 设置表头边框和内边距


            tooltipContent += '</tr>';
            jurisdictions.forEach(function (jurisdiction) {
              tooltipContent += '<tr>';
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.产生量} </td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.处置量}</td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.贮存量}</td>`; // 设置单元格边框和内边距

              tooltipContent += '</tr>';
            });
            tooltipContent += '</table></div>';

            return `<div> ${title}   ${tooltipContent}</div>`;
          }
        },

        dataset: {
          dimensions: ['date', '产生量', '处置量', '贮存量'],
          source: data
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            show: true,

            rotate: 40,

          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}吨'
          },
          splitLine: {
            show: false
          },
        },
        series: [{ type: 'line', smooth: true }, { type: 'line', smooth: true }, { type: 'line', smooth: true }]
      };
      const myChart = echarts.init(document.getElementById("dangerdata-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },

  mounted() {

    // 获取当前年份和月份 
    const currentMonth = this.$dayjs().format('YYYY-MM');
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, 'month').format('YYYY-MM');

    this.dates.push(lastMonth, currentMonth);
    this.getList();
  },
}
</script>

<style lang="scss" scoped>
.my-warning {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .my-warning-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .chart-content {
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 60px);

      .chart-card {
        border: 1px solid #909399;
        width: 44%;
        margin: 10px 3%;
        height: calc(50% - 30px);
        border-radius: 3px;

        .chart-title {
          width: 100%;
          text-align: center;
          height: 45px;
          line-height: 45px;
          border-bottom: 1px solid #909399;

          .title-text {
            cursor: pointer;
          }

        }

        .chart-main {
          width: 100%;
          height: calc(100% - 45px);

        }
      }
    }
  }

  .select-searchmain1 {
    width: 100%;
    height: 50px;
    display: flex;
    padding: 5px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      text-align: center;
      height: 100%;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }


}
</style>